import {COMMON} from '../../strings/common';
import {ORDER_TYPE, SCRIP_INSTRUMENTS, TRANSACTION_TYPES} from "../../constants/scripDetail";
import { isDate, isEmpty, map } from 'lodash-es';

export const getScripDetailPullRefreshError = (error = {}) => {
    const isNetworkError = error?.message === COMMON.networkErrorMessage;
    const errorMessage = isNetworkError ? COMMON.networkErrorMessage : COMMON.unableToLoadData;
    return errorMessage;
};

export const getScripInstrument = (instrument) => {
    switch (instrument) {
        case SCRIP_INSTRUMENTS.EQUITY:
            return SCRIP_INSTRUMENTS.EQUITY;
        case SCRIP_INSTRUMENTS.FUTURES:
            return SCRIP_INSTRUMENTS.FUTURES;
        case SCRIP_INSTRUMENTS.FUTURES_INDEX:
            return SCRIP_INSTRUMENTS.FUTURES_INDEX;
        case SCRIP_INSTRUMENTS.FUTURES_CURRENCY:
            return SCRIP_INSTRUMENTS.FUTURES_CURRENCY;
        case SCRIP_INSTRUMENTS.OPTIONS:
            return SCRIP_INSTRUMENTS.OPTIONS;
        case SCRIP_INSTRUMENTS.OPTION_INDEX:
            return SCRIP_INSTRUMENTS.OPTION_INDEX;
        case SCRIP_INSTRUMENTS.OPTIONS_CURRENCY:
            return SCRIP_INSTRUMENTS.OPTIONS_CURRENCY;
        default:
            return SCRIP_INSTRUMENTS.EQUITY;
    }
};


export const canMakeWaveApiCall = (isUiCacheEnabled, shouldRefresh, nextRefreshTime, data) => {
    if (!isUiCacheEnabled) return true;
    const currentTime = new Date();
    const isValidTime = isDate(currentTime) && isDate(nextRefreshTime);
    const isTimeExpired = isValidTime ? currentTime > nextRefreshTime : false;
    const isApiCall = isTimeExpired || shouldRefresh || isEmpty(data);
    return isApiCall;
};

export const getShouldRefreshStructure = (response = {}, shouldRefresh = false) => {
    const currentTime = new Date();
    const refreshDetails = {
        lastRefreshTime: response?.data_timestamp || currentTime,
        shouldRefresh: shouldRefresh || false,
        freq: response?.expiry_time || '',
        nextRefreshTime: response?.refresh_time || '',
        isUiCacheEnabled: response?.ui_cache_enabled,
    };
    return refreshDetails;
};


